import { useRef, useState, type RefObject } from 'react'

import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { HOTEL_DETAIL_COMPACT_LAYOUT_BREAKPOINT } from './constants'

function useHotelDetailCompactLayout(contentRef: RefObject<HTMLElement | null>) {
  const [isCompactLayout, setIsCompactLayout] = useState(false)
  const compactLayoutRef = useRef(false)

  useIsomorphicLayoutEffect(() => {
    const node = contentRef.current
    if (!node) return

    const updateLayout = (width: number) => {
      const nextIsCompactLayout = width < HOTEL_DETAIL_COMPACT_LAYOUT_BREAKPOINT
      // The resizer updates DOM widths directly. Only render when the layout changes.
      if (compactLayoutRef.current !== nextIsCompactLayout) {
        compactLayoutRef.current = nextIsCompactLayout
        setIsCompactLayout(nextIsCompactLayout)
      }
    }

    updateLayout(node.getBoundingClientRect().width)

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (entry) updateLayout(entry.contentRect.width)
    })
    observer.observe(node)

    return () => observer.disconnect()
  }, [contentRef])

  return isCompactLayout
}

export default useHotelDetailCompactLayout
